export enum AiQuotaType {
  NoUse = 0,
  Fixed = 1,            // Cố định
  NoReset = 2,          // Không reset
  Unlimited = 3         // Không giới hạn
}

// Map enum sang text
const aiQuotaTypeText: Record<AiQuotaType, string> = {
  [AiQuotaType.NoUse]: 'Không sử dụng',
  [AiQuotaType.Fixed]: 'Cố định',
  [AiQuotaType.NoReset]: 'Không reset',
  [AiQuotaType.Unlimited]: 'Không giới hạn'
};

// Hàm tiện ích
export function getAiQuotaTypeLabel(type: number): string {
  return aiQuotaTypeText[type as AiQuotaType] ?? '';
}

export const aiQuotaDurationOptions = [
  { text: "500", value: 500 },
  { text: "1000", value: 1000 },
  { text: "2000", value: 2000 },
  { text: "5000", value: 5000 },
];

